var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page flex flex-col bg-gray-900"},[_c('gc-header'),_vm._t("default"),_c('gc-footer')],2)}
var staticRenderFns = []

export { render, staticRenderFns }